"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    circle: function circle(_ref2) {
      var my = _ref2.my;
      return {
        display: 'inline-block',
        width: 34,
        height: 34,
        lineHeight: '32px',
        fontSize: 12,
        textAlign: 'center',
        background: 'var(--White)',
        border: '1px solid var(--Timber-Wolf-50)',
        borderRadius: '50%',
        textTransform: 'uppercase',
        margin: "0 ".concat(spacing(my))
      };
    }
  };
});

var Circle = function Circle(_ref3) {
  var _ref3$my = _ref3.my,
      my = _ref3$my === void 0 ? 1 : _ref3$my,
      className = _ref3.className,
      children = _ref3.children;
  var classes = useStyles({
    my: my
  });
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(classes.circle, className)
  }, children);
};

var _default = Circle;
exports["default"] = _default;